import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styles: [],
    standalone: false
})
export class SelectComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() { }
}
